import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import {environment} from "../../../../environments/environment";
import {INotificationModel, IResultNotificationModel} from "../../../models/accounts/notification.model";

const API_NOTIFICATION_URL = `${environment.apiUrl}/accounts/notification`;

@Injectable({
  providedIn: 'root'
})
export class NotificationHttpService {

  constructor(private http: HttpClient) { }

  find(id: number): Observable<INotificationModel> {
    let pars = new HttpParams();
    pars = pars.append('id', id);
    return this.http.get<INotificationModel>(API_NOTIFICATION_URL , {
      params: pars
    });
  }

  filter(wheres: { [key: string]: string }, limit: number = 100, offset: number = 0): Observable<IResultNotificationModel> {
    let pars = new HttpParams();
    Object.keys(wheres).forEach((key) => {
      pars = pars.append(key, wheres[key]);
    });
    pars = pars.append('offset', offset);
    pars = pars.append('limit', limit);
    return this.http.get<IResultNotificationModel>(API_NOTIFICATION_URL, {params: pars});
  }

  save(occupationModel: INotificationModel): Observable<INotificationModel> {
    const body = JSON.stringify(occupationModel);
    if (occupationModel.id) {
      return this.http.put<INotificationModel>(`${API_NOTIFICATION_URL + occupationModel.id}/`, body);
    } else {
      return this.http.post<INotificationModel>(API_NOTIFICATION_URL, body);
    }
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${API_NOTIFICATION_URL + id}/`);
  }
}
